import React from "react";
import Header from "./header";
import Sidebar from "./sidebar";
import { IoClose } from "react-icons/io5";
import { useUser } from "../config/userProvider";
import "../styles/Admin.css";
import MobileFooter from "./mobileFooter";
import { CiSearch } from "react-icons/ci";
import Card from "./card";
import { useTheme } from "../config/themeContext.js";
// import { IoSearch } from "react-icons/io5";
// import FixallAi from "./fixallAi.js";
// import { BsChatFill, BsSend } from "react-icons/bs";
// import { MdClose } from "react-icons/md";
// import { IoLogoAndroid } from "react-icons/io";
// import { DiApple } from "react-icons/di";
// import { RiMobileDownloadLine } from "react-icons/ri";
// import { toast } from "react-toastify";
// import PdfChatBot from "./pdfChatBot.js";


const Layout = ({ children }) => {
  const {
    // user,
    openProfile,
    setCloseProfile,
    isMenuOpen,
    setIsMenuOpen,
    showSearch,
    setShowSearch,
  } = useUser();

  // const [isButtonVisible, setIsButtonVisible] = useState(false);
  // const toggleButtonVisibility = () => {
  //   setIsButtonVisible(!isButtonVisible);
  // };
  // const [isOpen, setIsOpen] = useState(false); // State to toggle chat window

  const { theme, vendor } = useTheme();
  // console.log("theme 30 layout ", theme);
  // console.log("vendor 30 layout ", vendor);
  // console.log("saveTheme 30 layout ", saveTheme);



  return (
    <div
      className="layout h-screen w-full overflow-hidden bg-zinc-50"
      onClick={() => (openProfile === true ? setCloseProfile(false) : null)}
      style={{ backgroundColor: `${theme?.sideBar["bgColour"]}20` }}
    >

      {/* <PdfChatBot/> */}


      {/* <FixallAi /> */}
      <div className="flex gap-3  h-full md:p-2">
        <div
          style={{ backgroundColor: theme?.sideBar["bgColour"] }}
          className={` sm:relative transition-all duration-500 ease-in-out sm:translate-x-0 z-20 pb-8 overflow-hidden ${isMenuOpen
            ? "absolute flex w-3/4 z-40 opacity-100 translate-x-0"
            : "absolute flex w-3/4 sm:w-auto lg:w-[15%] -translate-x-full opacity-0 sm:opacity-100 "
            }    md:flex flex-col   md:relative  gap-4 items-center  h-full px-3 pt-2  shadow-sm bg-zinc-900  rounded-xl  `}
        >
          {/* <div
          className={`transition-all duration-500 ease-in-out lg:translate-x-0 ${
            isMenuOpen
              ? "absolute flex w-3/4 z-20 opacity-100 translate-x-0"
              : "absolute flex w-3/4 z-20 opacity-0 -translate-x-full"
          } md:flex flex-col md:relative gap-4 items-center h-full px-3 pt-2 shadow-sm bg-zinc-900 rounded-xl`}
        > */}

          <div className="w-full flex justify-between items-center">
            <div className="flex justify-center w-full">
              {
                vendor?.vendorDetails?.logo?.url ?
                  <img
                    className="w-auto h-10 lg:h-12 max-h-12 max-w-33 sm:block md:hidden lg:block"
                    src={vendor?.vendorDetails?.logo?.url}
                    alt="logo"
                  /> :

                  <img
                    className="w-auto h-10 lg:h-12 max-h-12 max-w-33 sm:block md:hidden lg:block brightness-[1000000]"
                    src="/logoWhite.png"
                    alt="logo"
                  />
              }
              {/* <img
                className="w-auto h-10 lg:h-12 max-h-12 max-w-33 sm:block md:hidden lg:block brightness-[1000000]"
                src="/logoWhite.png"
                alt="logo"
              /> */}
            </div>
            <div
              className="text-2xl text-white  block md:hidden cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              <IoClose />
            </div>
          </div>
          <Sidebar />
          <p className="absolute hidden bottom-0.5 bg-inherit w-full lg:flex justify-center h-5 items-center left-1/2 transform -translate-x-1/2 text-white text-[0.65rem]">
            Powered By{" "}
            <img
              src="/fixlabWhiteLogo.png"
              alt="FixLab Logo"
              className="h-5 ml-1"
            />
          </p>
        </div>

        {showSearch && (
          <Card.AddPopUp
            removePopUp={() => setShowSearch(false)}
            className="min-h-[90%]"
            height="90%"
          >
            <div className="bg-white sticky top-0 z-10 rounded-xl w-full shadow-md border">
              <div className="overflow-hidden border p-1 bg-transparent flex items-center text-xs md:text-base lg:text-lg gap-3 rounded-md px-2 py-2 md:px-4 md:py-2">
                <input
                  className=" bg-transparent border-none outline-none w-full"
                  placeholder="Search for something"
                />
                <CiSearch className="text-2xl" />
              </div>
            </div>
            <div className="mt-5 flex flex-col gap-2 h-[95%] py-5  overflow-auto  ">
              {[...Array(10)].map((_, index) => (
                <div className="w-full bg-zinc-50 p-4 rounded-md cursor-pointer hover:shadow-md drop-shadow-sm hover:drop-shadow-md  hover:border-zinc-300 border border-transparent">
                  <p className="text-lg font-semibold">Order confirmation</p>
                  <p className="text-xs line-clamp-2 text-zinc-600">
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s, when an unknown printer took a galley of
                    type and scrambled it to make a type ... Lorem Ipsum has
                    been the industry's standard dummy text ever since the
                    1500s, when an unknown printer took a galley of type and
                    scrambled it to make a type ... Lorem Ipsum has been the
                    industry's standard dummy text ever since the 1500s, when an
                    unknown printer took a galley of type and scrambled it to
                    make a type ...
                  </p>
                </div>
              ))}
            </div>
          </Card.AddPopUp>
        )}

        <div className="w-full  lg:w-[85%] flex flex-col overflow-hidden h-full ">
          {isMenuOpen && (
            <div
              className=" block lg:hidden w-full h-full fixed backdrop-blur-[0.2rem] z-30"
              onClick={() => setIsMenuOpen(false)}
            ></div>
          )}
          <Header className=" h-[10%]" />

          <div
            className=" rounded-xl h-[80%] sm:h-[90%] overflow-hidden"
            onClick={() => setCloseProfile(false)}
          >
            {children}
          </div>
          <MobileFooter />
        </div>
      </div>
    </div>
  );
};

export default Layout;

export const Container = ({ children, className, overflow, ...props }) => {
  return (
    <div
      className={`bg-white/100 relative rounded-2xl p-2  h-full ${className} ${overflow ? overflow : "overflow-hidden"
        } `}
      {...props}
    >
      {children}
    </div>
  );
};
